import React from 'react';
import { connect } from 'react-redux';
import { Table, Icon } from 'semantic-ui-react';
import { fetchEvents, createEvent } from '../../actions';
import { gameViewRenderer, hasEvents } from '../helpers/EventUtils';

const styles = {
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#888',
  },
  loadingState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#666',
  },
  tableHeader: {
    backgroundColor: '#f9f9f9',
  },
};

class UpcommingGameList extends React.Component {
  renderLoading = () => (
    <div style={styles.loadingState}>
      <Icon name="spinner" loading size="large" />
      <p style={{ marginTop: '10px' }}>Loading games...</p>
    </div>
  );

  renderEmptyState = () => (
    <div style={styles.emptyState}>
      <Icon name="calendar times" size="huge" style={{ marginBottom: '15px', opacity: 0.5 }} />
      <p>No games found for this period</p>
    </div>
  );

  renderGames = () => {
    const games = gameViewRenderer(this.props.events, this.props.view);

    if (!games || games.length === 0) {
      return this.renderEmptyState();
    }

    return (
      <Table basic="very" striped selectable>
        <Table.Header>
          <Table.Row style={styles.tableHeader}>
            <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Club</Table.HeaderCell>
            <Table.HeaderCell>Location</Table.HeaderCell>
            <Table.HeaderCell>Year</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{games}</Table.Body>
      </Table>
    );
  };

  render() {
    if (!this.props.view) {
      return null;
    }
    return hasEvents(this.props.events) ? this.renderLoading() : this.renderGames();
  }
}

const mapStateToProps = (state) => {
  return { events: state.events };
};

export default connect(mapStateToProps, { fetchEvents, createEvent })(UpcommingGameList);
